import * as React from 'react'

const ErrorIcon = (props) => (
  <svg
    width={306}
    height={255}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M294.565 132.446c0 34.257-13.992 65.137-36.428 87.332C236.183 241.731 205.786 255 172.252 255c-33.292 0-63.69-13.51-85.885-35.222-22.436-22.195-36.428-53.075-36.428-87.332 0-67.791 54.763-122.555 122.313-122.555 67.55 0 122.313 55.005 122.313 122.555ZM283.95 52.11c5.463 0 9.891-4.429 9.891-9.892 0-5.463-4.428-9.891-9.891-9.891s-9.891 4.428-9.891 9.891 4.428 9.891 9.891 9.891ZM298.424 13.51a6.754 6.754 0 1 0 0-13.51 6.754 6.754 0 0 0 0 13.51ZM53.798 51.867a6.755 6.755 0 1 0 0-13.509 6.755 6.755 0 0 0 0 13.51ZM12.545 182.143c6.928 0 12.545-5.617 12.545-12.545s-5.617-12.545-12.545-12.545S0 162.67 0 169.598s5.617 12.545 12.545 12.545Z"
      fill="#EAEEF9"
    />
    <path
      d="M243.958 159.858H101.04c-5.606 0-10.153-4.547-10.153-10.153v-33.163c0-5.606 4.547-10.154 10.153-10.154h142.915c5.609 0 10.154 4.548 10.154 10.154v33.16c.003 5.609-4.545 10.156-10.151 10.156Z"
      fill="#D5DDEA"
    />
    <g filter="url(#a)">
      <path
        d="M243.958 106.388H101.04c-5.606 0-10.153-4.548-10.153-10.154V63.072c0-5.606 4.547-10.154 10.153-10.154h142.915c5.609 0 10.156 4.548 10.156 10.154v33.16c0 5.608-4.547 10.156-10.153 10.156Z"
        fill="url(#b)"
      />
    </g>
    <g filter="url(#c)">
      <path
        d="M243.958 213.329H101.04c-5.606 0-10.153-4.548-10.153-10.154v-33.163c0-5.606 4.547-10.154 10.153-10.154h142.915c5.609 0 10.154 4.548 10.154 10.154v33.16c.003 5.609-4.545 10.157-10.151 10.157Z"
        fill="url(#d)"
      />
    </g>
    <path
      d="M117.622 89.503c5.44 0 9.85-4.41 9.85-9.85 0-5.44-4.41-9.85-9.85-9.85-5.44 0-9.85 4.41-9.85 9.85 0 5.44 4.41 9.85 9.85 9.85Z"
      fill="#989FB0"
    />
    <path
      d="M228.783 78.246a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628ZM217.527 78.246a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628ZM234.413 86.689a2.814 2.814 0 1 0 0-5.629 2.814 2.814 0 0 0 0 5.629ZM223.155 86.689a2.814 2.814 0 1 0 0-5.629 2.814 2.814 0 0 0 0 5.629ZM206.27 78.246a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628ZM211.898 86.689a2.814 2.814 0 1 0 0-5.629 2.814 2.814 0 0 0 0 5.629ZM195.013 78.246a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628ZM200.642 86.689a2.814 2.814 0 1 0 0-5.629 2.814 2.814 0 0 0 0 5.629ZM183.756 78.246a2.813 2.813 0 1 0 .001-5.627 2.813 2.813 0 0 0-.001 5.627ZM189.385 86.689a2.814 2.814 0 1 0 0-5.629 2.814 2.814 0 0 0 0 5.629Z"
      fill="#D5DDEA"
    />
    <path
      d="M117.622 142.973c5.44 0 9.85-4.41 9.85-9.85 0-5.44-4.41-9.849-9.85-9.849-5.44 0-9.85 4.409-9.85 9.849s4.41 9.85 9.85 9.85ZM228.783 131.716a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628ZM217.527 131.716a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628ZM234.413 140.158a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628ZM223.155 140.158a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628ZM206.27 131.716a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628ZM211.898 140.158a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628ZM195.013 131.716a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628ZM200.642 140.158a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628ZM183.756 131.716a2.814 2.814 0 1 0 0-5.627 2.814 2.814 0 0 0 0 5.627ZM189.385 140.158a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628ZM117.622 196.443c5.44 0 9.85-4.41 9.85-9.849 0-5.44-4.41-9.85-9.85-9.85-5.44 0-9.85 4.41-9.85 9.85 0 5.439 4.41 9.849 9.85 9.849Z"
      fill="#989FB0"
    />
    <path
      d="M228.783 185.186a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628ZM217.527 185.186a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628ZM234.413 193.629a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628ZM223.155 193.629a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628ZM206.27 185.186a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628ZM211.898 193.629a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628ZM195.013 185.186a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628ZM200.642 193.629a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628ZM183.756 185.186a2.814 2.814 0 1 0 0-5.627 2.814 2.814 0 0 0 0 5.627ZM189.385 193.629a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628Z"
      fill="#D5DDEA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m233.844 19.253-29.013 50.25A5.969 5.969 0 0 0 210 78.455h58.022a5.97 5.97 0 0 0 5.97-5.97 5.97 5.97 0 0 0-.801-2.984l-29.01-50.249a5.97 5.97 0 0 0-8.152-2.184 5.965 5.965 0 0 0-2.185 2.184Zm5.547 15.499h-.757a3.374 3.374 0 0 0-3.374 3.374v16.126a3.374 3.374 0 0 0 3.374 3.374h.757a3.373 3.373 0 0 0 3.373-3.374V38.126a3.373 3.373 0 0 0-3.373-3.374Zm3.372 31.91a3.752 3.752 0 1 1-7.504 0 3.752 3.752 0 0 1 7.504 0Z"
      fill="#989FB0"
    />
    <defs>
      <linearGradient
        id="b"
        x1={172.446}
        y1={51.681}
        x2={172.446}
        y2={106.964}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.996} stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={172.445}
        y1={158.622}
        x2={172.445}
        y2={213.905}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.996} stopColor="#ECF0F5" />
      </linearGradient>
      <filter
        id="a"
        x={77.614}
        y={46.281}
        width={189.771}
        height={80.016}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={6.637} />
        <feGaussianBlur stdDeviation={6.637} />
        <feColorMatrix values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5504_69656"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_5504_69656"
          result="shape"
        />
      </filter>
      <filter
        id="c"
        x={77.614}
        y={153.222}
        width={189.768}
        height={80.016}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={6.637} />
        <feGaussianBlur stdDeviation={6.637} />
        <feColorMatrix values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5504_69656"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_5504_69656"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

export { ErrorIcon }
